////////////////////////////////////////////////////////////
//     							                                      //
//  Program: SubMetro.jsx                            //
//  Application: Location                                   //
//  Option: to view SubMetro data                   //
//  Developer: Ashish Kumar  						                  //
//  Date: 2022-01-06                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Button, Table, Modal, Form, InputGroup } from "react-bootstrap";
import Alerts from "../common/Alerts";
import deleteicon from "../../assets/images/delete.svg";
import SimpleReactValidator from "simple-react-validator";
import MetroService from "../../services/MetroService";
import SubMetroService from "../../services/SubMetroService";
import modaldeleteicon from "./../../assets/images/delete.svg";
import pluswIcon from "./../../assets/images/plus.svg";
import Select from "react-select";
import { Container } from "react-bootstrap";
import MasterSidebar from "../common/MasterSidebar";
import NoData from "../common/NoData";

export class SubMetro extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      slug: "",
      //for sub metro
      addSubMetroModal: false,
      editSubMetroModal: false,
      deleteSubMetroModal: false,
      metroList: [],
      newMetroList: [],
      selectedMetroList: [],
      subMetroList: [],
      subMetroListTotal: 0,
      sub_metro_name: "",
      metro_slug: "",
      sort_order: "",
    };

    this.changeHandler = this.changeHandler.bind(this);
    /* for sub metro */
    this.openAddSubMetroModal = this.openAddSubMetroModal.bind(this);
    this.openEditSubMetroModal = this.openEditSubMetroModal.bind(this);
    this.openDeleteSubMetroModal = this.openDeleteSubMetroModal.bind(this);
    this.saveSubMetro = this.saveSubMetro.bind(this);
    this.updateSubMetro = this.updateSubMetro.bind(this);
    this.getSubMetroDetails = this.getSubMetroDetails.bind(this);
    this.deleteSubMetro = this.deleteSubMetro.bind(this);
  }

  componentDidMount() {
    this.getSubMetroData();
  }

  /* to get metro list data */
  async getMetroData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var metroList = [];
    var metroListTotal = 0;

    let res = await MetroService.getMetro(
      "is_dropdown=1",
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      metroList = res.data ? res.data : [];
      metroListTotal = metroList ? metroList.length : 0;
    }
    const newMetroList =
      metroListTotal > 0
        ? metroList.map(({ slug, metro_name }) => ({
            value: slug,
            label: metro_name,
          }))
        : [];
    this.setState({
      metroList: metroList,
      metroListTotal: metroListTotal,
      newMetroList: newMetroList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* to get sub metro list data */
  async getSubMetroData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var subMetroList = [];
    var subMetroListTotal = 0;

    let res = await SubMetroService.getSubMetro(
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      subMetroList = res.data.data ? res.data.data : [];
      subMetroListTotal = subMetroList ? subMetroList.length : 0;
    }
    this.setState({
      subMetroList: subMetroList,
      subMetroListTotal: subMetroListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* to save sub metro data */
  saveSubMetro = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.sub_metro_name &&
      !this.validator.errorMessages.metro &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        sub_metro_name: this.state.sub_metro_name,
        metro_slug: this.state.metro_slug,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await SubMetroService.createSubMetro(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddSubMetroModal();
        this.setState({
          sub_metro_name: "",
          metro_slug: "",
          sort_order: "",
          status_id: true,
        });
        this.getSubMetroData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to get sub metro details data */
  async getSubMetroDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await SubMetroService.getSubMetroBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.sub_metro_name = res.data.sub_metro_name
          ? res.data.sub_metro_name
          : "";
        resData.metro_slug = res.data.metro ? res.data.metro.slug : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.status_id = res.data.status_id === 1 ? true : false;
        var selectedMetroList = [];
        selectedMetroList = res.data.metro
          ? [
              {
                value: res.data.metro.slug,
                label: res.data.metro.metro_name,
              },
            ]
          : "";
      }
      this.setState(resData);
      this.setState({ selectedMetroList: selectedMetroList });
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  /* to update sub metro data */
  updateSubMetro = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.sub_metro_name &&
      !this.validator.errorMessages.metro &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        sub_metro_name: this.state.sub_metro_name,
        metro_slug: this.state.metro_slug,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await SubMetroService.updateSubMetro(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditSubMetroModal();
        this.setState({
          sub_metro_name: "",
          metro_slug: "",
          sort_order: "",
          status_id: true,
        });
        this.getSubMetroData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to delete sub metro data */
  async deleteSubMetro(slug) {
    this.setState({ showSpinner: true });
    let res = await SubMetroService.deleteSubMetro(slug);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteSubMetroModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });

      this.getSubMetroData();
    } else {
      this.closeDeleteSubMetroModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    this.closeDeleteSubMetroModal();
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  handleChangeMetroList(value) {
    let metro_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        metro_slug.push(item.value);
      });
    }
    const metro_slug_value = value !== null ? value.value : [];
    this.setState({
      selectedMetroList: value,
      metro_slug: metro_slug_value,
    });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  /* Sub Metro Modals */
  openAddSubMetroModal() {
    this.getMetroData();
    this.setState({ addSubMetroModal: true });
  }

  closeAddSubMetroModal() {
    this.setState({ addSubMetroModal: false });
    this.setState({
      sub_metro_name: "",
      metro_slug: "",
      sort_order: "",
      errors: "",
      status_id: true,
      selectedMetroList: [],
    });
    this.validator.hideMessages();
  }

  openEditSubMetroModal(slug) {
    this.getSubMetroDetails(slug);
    this.getMetroData();
    this.setState({ editSubMetroModal: true });
    this.setState({ slug: slug });
  }

  closeEditSubMetroModal() {
    this.setState({ editSubMetroModal: false });
    this.setState({
      slug: "",
      sub_metro_name: "",
      metro_slug: "",
      sort_order: "",
      errors: "",
      status_id: true,
      selectedMetroList: [],
    });
    this.validator.hideMessages();
  }

  openDeleteSubMetroModal(slug) {
    this.setState({ deleteSubMetroModal: true });
    this.setState({ slug: slug });
  }

  closeDeleteSubMetroModal() {
    this.setState({ deleteSubMetroModal: false });
    this.setState({ slug: "" });
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({ behavior: "auto", block: "start" });
  }

  getTitle() {
    return "Sub Metro";
  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        // color: state.isSelected ? 'black' : ((state.isSelected && state.isFocused) ? "white" : ( state.isFocused && 'white')),
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };

    return (
      <>
        {/* Sub Metro Card */}
        {/* <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="34"
              id="34"
              onClick={(e) => this.setOpen(!this.state.open, e)}
            >
              Sub Metro
              <i className="mdi mdi-view-headline"> </i>
              {this.state.open && this.state.eventKey === "34" ? (
                <i className="fas fa-chevron-down"></i>
              ) : (
                <i className="fas fa-chevron-up"></i>
              )}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="34">
            <Card.Body>
              <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
                <Button
                  variant="outline-dark btn-block btn-with-icon"
                  onClick={this.openAddSubMetroModal}
                >
                  <img src={pluswIcon} /> Add
                </Button>
              </div>
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="table-responsive">
                <Table hover className="mg-b-0">
                  <thead>
                    <tr>
                      <th className="w-50">Sub Metro Name</th>
                      <th className="w-50">Metro Name</th>
                      <th className="w-25">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.subMetroListTotal > 0 ? (
                      this.state.subMetroList.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td className="hand-cursor" onClick={() =>
                              this.openEditSubMetroModal(item.slug)
                            }>{item.sub_metro_name ? item.sub_metro_name : ''}</td>
                            <td>{item.metro ? item.metro.metro_name : ''}</td>
                            <td>
                              {item.status_id === 1 ? (
                                <b className="active"></b>
                              ) : (
                                <b></b>
                              )}
                            </td>
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteSubMetroModal(item.slug)
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          No rows found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card> */}

        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {global.userPermissions.checkPermission(
                          "master-data-add"
                        ) && (
                          <Button
                            variant="outline-dark btn-block btn-with-icon"
                            onClick={this.openAddSubMetroModal}
                          >
                            <img src={pluswIcon} alt="" /> Add
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      {/* <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
              <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddSubMetroModal}
              >
                <img src={pluswIcon} alt="" /> Add
              </Button>
            </div> */}
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.subMetroListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                            <tr>
                              <th className="w-30">Sub Metro Name</th>
                              <th className="w-30">Metro Name</th>
                              <th className="w-35">Status</th>
                              {global.userPermissions.checkPermission(
                                "master-data-delete"
                              ) && <th className="text-center">Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.subMetroListTotal > 0 ? (
                              this.state.subMetroList.map((item, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      className="hand-cursor"
                                      onClick={() => {
                                        global.userPermissions.checkPermission(
                                          "master-data-update"
                                        ) &&
                                          this.openEditSubMetroModal(item.slug);
                                      }}
                                    >
                                      {item.sub_metro_name
                                        ? item.sub_metro_name
                                        : ""}
                                    </td>
                                    <td>
                                      {item.metro ? item.metro.metro_name : ""}
                                    </td>
                                    <td>
                                      {item.status_id === 1 ? (
                                        <b className="active"></b>
                                      ) : (
                                        <b></b>
                                      )}
                                    </td>
                                    {global.userPermissions.checkPermission(
                                      "master-data-delete"
                                    ) && (
                                      <td>
                                        <div className="btn-icon-list d-block text-center">
                                          <img
                                            src={deleteicon}
                                            alt=""
                                            onClick={() =>
                                              this.openDeleteSubMetroModal(
                                                item.slug
                                              )
                                            }
                                            className="hand-cursor"
                                          />
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" align="center">
                                  There are no sub metros added in the system.
                                  You may add them by clicking Add button.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage("SUBMETRO")}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add Sub Metro popup modal */}
        <Modal
          show={this.state.addSubMetroModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddSubMetroModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddSubMetroModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Sub Metro</h3>
            <label>Sub Metro Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="sub_metro_name"
              value={this.state.sub_metro_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Sub Metro Name"
            />
            {this.state.errors.sub_metro_name ? (
              <div className="text-danger">
                {this.state.errors.sub_metro_name}
              </div>
            ) : (
              this.validator.message(
                "sub_metro_name",
                this.state.sub_metro_name,
                "required|max:50",
                { className: "text-danger" }
              )
            )}
            <InputGroup className="mt-3">
              <label>Metro</label>
              <div className="col-md-12 p-0">
                <Select
                  styles={customStyles}
                  isClearable={true}
                  menuPlacement="auto"
                  className="multiselect"
                  classNamePrefix={"my-custom-react-select"}
                  options={this.state.newMetroList}
                  getOptionValue={(option) => `${option.label}`}
                  onChange={(value) => this.handleChangeMetroList(value)}
                  defaultValue={this.state.selectedMetroList}
                  value={this.state.selectedMetroList}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 2,
                    colors: {
                      ...theme.colors,
                      primary: "#fff",
                      primary75: "#000",
                      primary50: "#000",
                      primary25: "#000",
                    },
                  })}
                />
              </div>
              {/* <select
                // className="form-control max_width_100"
                onChange={this.changeHandler}
                name="metro_slug"
                value={this.state.metro_slug}
              >
                <option key="" value="">
                  Select Metro
                </option>
                {this.state.metroList.map((option) => (
                  <option
                    className="form-control"
                    key={option.slug}
                    value={option.slug}
                  >
                    {option.metro_name}
                  </option>
                ))}
              </select> */}
            </InputGroup>
            {this.state.errors.metro_slug ? (
              <div className="text-danger">{this.state.errors.metro_slug}</div>
            ) : (
              this.validator.message(
                "metro",
                this.state.metro_slug,
                "required",
                { className: "text-danger" }
              )
            )}
            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddSubMetroModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveSubMetro}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit Sub Metro popup modal */}
        <Modal
          show={this.state.editSubMetroModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditSubMetroModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditSubMetroModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Sub Metro</h3>
            <label>Sub Metro Name</label>
            <Form.Control
              onChange={this.changeHandler}
              name="sub_metro_name"
              value={this.state.sub_metro_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Sub Metro Name"
            />
            {this.state.errors.sub_metro_name ? (
              <div className="text-danger">
                {this.state.errors.sub_metro_name}
              </div>
            ) : (
              this.validator.message(
                "sub_metro_name",
                this.state.sub_metro_name,
                "required|max:50",
                { className: "text-danger" }
              )
            )}
            <InputGroup className="mt-3">
              <label>Metro</label>
              <div className="col-md-12 p-0">
                <Select
                  styles={customStyles}
                  isClearable={true}
                  menuPlacement="auto"
                  className="multiselect"
                  classNamePrefix={"my-custom-react-select"}
                  options={this.state.newMetroList}
                  getOptionValue={(option) => `${option.label}`}
                  onChange={(value) => this.handleChangeMetroList(value)}
                  defaultValue={this.state.selectedMetroList}
                  value={this.state.selectedMetroList}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 2,
                    colors: {
                      ...theme.colors,
                      primary: "#fff",
                      primary75: "#000",
                      primary50: "#000",
                      primary25: "#000",
                    },
                  })}
                />
              </div>
              {/* <select
                // className="form-control max_width_100"
                onChange={this.changeHandler}
                name="metro_slug"
                value={this.state.metro_slug}
              >
                <option key="" value="">
                  Select Metro
                </option>
                {this.state.metroList.map((option) => (
                  <option
                    className="form-control"
                    key={option.slug}
                    value={option.slug}
                  >
                    {option.metro_name}
                  </option>
                ))}
              </select> */}
            </InputGroup>
            {this.state.errors.metro_slug ? (
              <div className="text-danger">{this.state.errors.metro_slug}</div>
            ) : (
              this.validator.message(
                "metro",
                this.state.metro_slug,
                "required",
                { className: "text-danger" }
              )
            )}
            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}
            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "active" : "inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditSubMetroModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.updateSubMetro}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete Sub Metro popup modal */}
        <Modal
          show={this.state.deleteSubMetroModal}
          // onHide={() => {
          //   if (
          //     window.confirm("Are you sure to exit the pop up without delete?")
          //   )
          //     this.closeDeleteSubMetroModal();
          // }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closeDeleteSubMetroModal()}
              >
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteSubMetroModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteSubMetro(this.state.slug)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default SubMetro;
